import script from "./AddToBasketButtonContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddToBasketButtonContent.vue?vue&type=script&lang=ts&setup=true"

import "./AddToBasketButtonContent.vue?vue&type=style&index=0&id=7733fce8&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7733fce8"]])

export default __exports__